import {postJackpotIssue} from '../api/postJackpotIssue';

const setPostJackpotIssue = (params) => {
    return async (dispatch, getState) => {
        try {
            await postJackpotIssue(params);     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostJackpotIssue
}